import { parseISO, format as formatDatetime } from 'date-fns';
import { is } from 'date-fns/locale';

interface IFormatOptions {
  locale?: any;
}

export function format(date: string | number | null, locale: string = 'is'): string | null {
  if (!date) {
    return null;
  }

  // TODO Should be using Intl here.. but there are locale inconsistencies, see README
  const options: IFormatOptions = {};
  if (locale === 'is') {
    options.locale = is;
  }

  const parsed = typeof date === 'string' ? parseISO(date) : date;

  const localeFormat = locale === 'is' ? 'd. MMMM yyyy' : 'MMMM do, yyyy';

  const formatted = formatDatetime(parsed, localeFormat, options);

  return formatted;
}

export function formatDate(date: string | number | null, locale: string = 'is'): string | null {
  if (!date) {
    return null;
  }

  const parsed = typeof date === 'string' ? parseISO(date) : date;

  const localeFormat = 'dd.MM';

  const formatted = formatDatetime(parsed, localeFormat);

  return formatted;
}


export function formatTime(date: string | number | null, locale: string = 'is'): string | null {
  if (!date) {
    return null;
  }

  // TODO Should be using Intl here.. but there are locale inconsistencies, see README
  const options: IFormatOptions = {};
  if (locale === 'is') {
    options.locale = is;
  }

  const parsed = typeof date === 'string' ? parseISO(date) : date;

  const localeFormat = locale === 'is' ? 'H:mm' : 'p';

  const formatted = formatDatetime(parsed, localeFormat, options);

  return formatted;
}
